import {Controller} from "@hotwired/stimulus"


/**
 * This controller listens for the `select-search:entity_selected` event
 * dispatched by the `SelectSearchController`. Its purpose is to update
 * the `entity_id` query parameter in the URL (href) of the element
 * it is attached to.
 *
 * This is useful for synchronizing links with
 * the currently selected entity in a SelectSearch dropdown.
 *
 * Example usage:
 * %a{ href: '/some/path', data: { controller: 'entity-change' } }
 */
export default class extends Controller {
  connect() {
    super.connect();

    this.entitySelectedHandler = this._handleEntitySelected.bind(this);
    window.addEventListener('select-search:entity_selected', this.entitySelectedHandler);
  }

  disconnect() {
    super.disconnect();
    window.removeEventListener('select-search:entity_selected', this.entitySelectedHandler);
  }

  _handleEntitySelected(event) {
    this._addOrReplaceEntityInLink(event.detail.entityId);
  }

  _addOrReplaceEntityInLink(entityId) {
    const url = new URL(this.element.href);
    if (url.searchParams.has('entity_id')) {
      url.searchParams.set('entity_id', entityId);
    } else {
      url.searchParams.append('entity_id', entityId);
    }
    this.element.href = url.toString();
  }
}